import React, {useEffect} from 'react';
import {Form, Grid} from 'semantic-ui-react';
import {getDropdownOptions} from '../../../../common/util/dropdown';

const GeneralInfoForm = ({
  formData,
  setFormData,
  reduxData,
  errors,
  statusOptions,
  onCourseChange,
  onParticipantsChange,
  setPreEvaluacionError,
}) => {
  const validateDates = (fechaPre, fechaInsc, fechaIni) => {
    if (!fechaPre || !fechaInsc || !fechaIni) {
      return null;
    }

    if (fechaPre.length !== 10 || fechaInsc.length !== 10 || fechaIni.length !== 10) {
      return null;
    }

    const pre = new Date(fechaPre).getTime();
    const insc = new Date(fechaInsc).getTime();
    const ini = new Date(fechaIni).getTime();

    if (isNaN(pre) || isNaN(insc) || isNaN(ini)) {
      return null;
    }

    if (pre < insc || pre > ini) {
      return 'Debe estar entre límite de inscripción e inicio';
    }
    return null;
  };

  useEffect(() => {
    if (formData.idCursoReferencia && reduxData.courses) {
      const selectedCourse = reduxData.courses.find(
        (c) => String(c.id) === String(formData.idCursoReferencia)
      );
      if (selectedCourse) {
        setFormData((prev) => ({
          ...prev,
          'tiempoExperiencia': selectedCourse.prerequisite || 0,
        }));
      }
    }
  }, [formData.idCursoReferencia, reduxData.courses, setFormData]);

  useEffect(() => {
    if (setPreEvaluacionError) {
      const errorMessage = validateDates(
        formData.fechaLimitePrimeraEvaluacion,
        formData.fechaLimiteInscripcion,
        formData.fechaInicio
      );
      setPreEvaluacionError(errorMessage !== null);
    }
  }, [
    formData.fechaLimitePrimeraEvaluacion,
    formData.fechaLimiteInscripcion,
    formData.fechaInicio,
    setPreEvaluacionError,
  ]);

  const getNextId = () => {
    if (formData.id) {
      return formData.id;
    }
    const lastIdData = reduxData.lastId;
    const lastIdValue = lastIdData && typeof lastIdData === 'object' ?
      lastIdData.ultimo_id : lastIdData;

    if (lastIdValue !== null && typeof lastIdValue !== 'symbol' && lastIdValue !== '') {
      const numericId = Number(lastIdValue);
      return !isNaN(numericId) ? numericId + 1 : '';
    }
    return '';
  };

  const isPreEvaluacionEnabled = formData.fechaInicio && formData.fechaLimiteInscripcion;

  const currentPreEvalError = validateDates(
    formData.fechaLimitePrimeraEvaluacion,
    formData.fechaLimiteInscripcion,
    formData.fechaInicio
  );

  const handleDateChange = (name, value) => {
    setFormData({...formData, [name]: value});
  };

  return (
    <Grid stackable>
      <Grid.Row columns={2} style={{'paddingBottom': '10px'}}>
        <Grid.Column>
          <Form.Input
            label="Departamento"
            value={reduxData.areaSelected?.description || ''}
            disabled
          />
        </Grid.Column>
        <Grid.Column>
          <Form.Input
            label="ID Agenda"
            value={getNextId()}
            disabled
            placeholder="Asignando ID..."
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row style={{'paddingBottom': '10px'}}>
        <Grid.Column>
          <Form.Dropdown
            required
            fluid
            search
            selection
            label="Seleccionar Curso"
            value={formData.idCursoReferencia}
            options={getDropdownOptions((reduxData.courses || []).filter((c) => c.status === 'ACTIVO'), 'id', 'course')}
            onChange={(ev, {value}) => {
              onCourseChange(value);
            }}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={3} style={{'paddingBottom': '10px'}}>
        <Grid.Column>
          <Form.Input
            type="date"
            label="Inicio"
            name="fechaInicio"
            value={formData.fechaInicio || ''}
            onChange={(e, d) => handleDateChange(d.name, d.value)}
            required
            disabled={!formData.idCursoReferencia}
            error={errors.fechaInicio ? {'content': errors.fechaInicio, 'pointing': 'above'} : false}
          />
        </Grid.Column>
        <Grid.Column>
          <Form.Input
            type="date"
            label="Fin"
            name="fechaHasta"
            value={formData.fechaHasta || ''}
            onChange={(e, d) => handleDateChange(d.name, d.value)}
            required
            disabled={!formData.idCursoReferencia}
            error={errors.fechaHasta ? {'content': errors.fechaHasta, 'pointing': 'above'} : false}
          />
        </Grid.Column>
        <Grid.Column>
          <Form.Input
            type="date"
            label="Fecha límite Inscripción"
            name="fechaLimiteInscripcion"
            value={formData.fechaLimiteInscripcion || ''}
            onChange={(e, d) => handleDateChange(d.name, d.value)}
            required
            disabled={!formData.idCursoReferencia}
            error={errors.fechaLimiteInscripcion ? {'content': errors.fechaLimiteInscripcion,
              'pointing': 'above'} : false}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={3} style={{'paddingBottom': '10px'}}>
        <Grid.Column>
          <Form.Input
            type="date"
            label="Fecha Pre Evaluación"
            name="fechaLimitePrimeraEvaluacion"
            value={formData.fechaLimitePrimeraEvaluacion || ''}
            onChange={(e, d) => handleDateChange(d.name, d.value)}
            required
            disabled={!isPreEvaluacionEnabled}
            error={currentPreEvalError ? {'content': currentPreEvalError, 'pointing': 'above'} : false}
          />
        </Grid.Column>
        <Grid.Column>
          <Form.Dropdown
            fluid
            selection
            search
            label="Instructor"
            name="instructor"
            value={formData.instructor || ''}
            options={getDropdownOptions(reduxData.instructors, 'fullName', 'fullName')}
            onChange={(ev, {value}) => {
              setFormData((p) => ({...p, 'instructor': value}));
            }}
            disabled={!formData.idCursoReferencia}
          />
        </Grid.Column>
        <Grid.Column>
          <Form.Input
            label="Experiencia"
            value={formData.tiempoExperiencia ? `${formData.tiempoExperiencia} meses` : '0 meses'}
            readOnly
            disabled={!formData.idCursoReferencia}
          />
        </Grid.Column>
      </Grid.Row>
      <Grid.Row columns={2} style={{'paddingBottom': '10px'}}>
        <Grid.Column>
          <Form.Dropdown
            fluid
            selection
            label="Estado"
            name="estado"
            value={formData.estado || ''}
            options={statusOptions}
            onChange={(ev, {value}) => {
              setFormData((p) => ({...p, 'estado': value}));
            }}
            disabled={!formData.idCursoReferencia}
          />
        </Grid.Column>
        <Grid.Column>
          <Form.Input
            type="number"
            label="Total Participantes"
            name="numParticipantes"
            min={0}
            value={formData.numParticipantes || 0}
            onChange={(ev, {value}) => {
              onParticipantsChange(value);
            }}
            disabled={!formData.idCursoReferencia}
          />
        </Grid.Column>
      </Grid.Row>
    </Grid>
  );
};

export default GeneralInfoForm;
